import { render, staticRenderFns } from "./grupo.vue?vue&type=template&id=4dea17d0&scoped=true&"
import script from "./grupo.vue?vue&type=script&lang=js&"
export * from "./grupo.vue?vue&type=script&lang=js&"
import style0 from "./grupo.vue?vue&type=style&index=0&id=4dea17d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dea17d0",
  null
  
)

export default component.exports